import { fabric } from "fabric";
import { Textarea } from "../elements/textarea";
import { TextareaFieldItem } from "../state/types";
import { RenderContext } from "./fabric-renderer";

export function renderTextareaField(
  context: RenderContext,
  item: TextareaFieldItem,
  element: Textarea | undefined,
): fabric.Object {
  const fieldValue = context.data[item.field_slug] ?? "";
  const pageBreakMargin = context.dimensions.pageBreakMargin ?? 0;

  const textareaElement = createTextareaElement(element);
  textareaElement.setOptions({
    id: item.id,
    left: item.left,
    top: item.top,
    width: item.width,
    height: item.height,
    scaleX: 1,
    scaleY: 1,
    text: fieldValue,
    fill: item.fill,
    fontSize: item.fontSize,
    fontFamily: item.fontFamily,
    fontWeight: item.fontWeight,
    textAlign: item.textAlign,
    lineHeight: item.lineHeight,
    stroke: item.stroke,
    strokeWidth: item.strokeWidth,
    lockScalingY: true,
    editable: false,
    pageHeight: context.dimensions.height,
    pageBreakMargin,
    data: {
      strokeStyle: item.stroke,
      lineWidth: item.strokeWidth,
    },
  });

  textareaElement.recalculate();

  return textareaElement;
}

function createTextareaElement(element: Textarea | undefined): Textarea {
  // Create a new element if it does not exist or it was removed from the canvas
  if (!element) {
    element = new Textarea();
  }

  return element;
}
